module.exports = __webpack_public_path__ + "img/8.fb85a443.png";